import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "app/services/auth/auth.service";
import { catchError, Observable, throwError } from "rxjs";

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
	authSvc = inject(AuthService);

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				let errorMsg = "";

				if (error.error instanceof ErrorEvent) {
					errorMsg = `[CLIENT ERROR] ${error.error.message}`;
				} else {
					errorMsg = `[SERVER ERROR] [${error.status}: ${error.statusText}] [${error.url}] ${JSON.stringify(
						error.error?.error_description || error.error?.message || error.message,
						null,
						2
					)}`;
				}

				console.error(errorMsg, error);
				return throwError(() => error);
			})
		);
	}
}
